import { FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';

export function handleFieldOnChange(name: string, value: string, errorText: string, callback: FieldChangeCallback, required = true) {
	let valid = true;

	const errorTextArray = [];

	if (required && !value) {
		valid = false;
		errorTextArray.push(errorText);
	}

	callback(name, value, valid, errorTextArray);
}
